import React, { useContext, useEffect } from 'react';
import { useLocation, withRouter } from 'react-router-dom';
import SharedContext from '../contexts/SharedContext';
import PrintContext from '../contexts/PrintContext';
import MobileContext from '../contexts/MobileContext';
import PublicContext from '../contexts/PublicContext';
import Header, { positionPaths } from '../modules/header/HeaderComponent';
import ApplicationRoutes from './ApplicationRoutes';
import ApplicationSvgFilters from './ApplicationSvgFilters';
import getStyles from './ApplicationStyle';
import './ApplicationIcons';
import useWhiteBackground from '../utils/useWhiteBackground';
import SocialIntentsLiveChat from '../widgets/socialintents-live-chat/SocialIntentsLiveChat';
import useSetTitle from '../hooks/useSetTitle';

const App = () => {
    const isShared = useContext(SharedContext);
    const isPrint = useContext(PrintContext);

    const isPublicMode = useContext(PublicContext);
    const { isMobile } = useContext(MobileContext);

    const location = window.location.href;
    const isWhiteBackground = useWhiteBackground();

    const canRenderHeader = !isShared
        && !isPrint
        && (!positionPaths.test(location) || location.includes('wizard'));

    const classes = getStyles({
        canRenderHeader,
        isMobile,
        isPublicMode,
        isWhiteBackground,
    });

    const setTitle = useSetTitle();
    const routeLocation = useLocation();

    useEffect(() => {
        const paths = routeLocation.pathname.split('/');
        setTitle(paths);
    }, [routeLocation.pathname]);

    return (
        <div className={classes.application}>
            { canRenderHeader && <Header/> }
            <ApplicationRoutes />
            <ApplicationSvgFilters />
            <SocialIntentsLiveChat />
        </div>
    );
};

export default withRouter(App);
